import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { type LocationDocument } from "~/gql/graphqlBase.generated";
import tenantChanged from "~/store/tenantChanged";

// Define a type for the slice state
interface SiteState {
	hasInitializedChoice?: boolean;
	location: LocationDocument | undefined;
	// Tenant the location was selected under — stamped by siteTenantStampMiddleware; compared against settings.tenantId by RequireSite.
	tenantId?: string;
}

const initialState: SiteState = {
	hasInitializedChoice: false,
	location: undefined
};

export const siteSlice = createSlice({
	extraReducers: (builder) => {
		builder.addCase(tenantChanged, () => initialState);
	},
	initialState,
	name: "site",
	reducers: {
		stampSiteTenantId: (state, action: PayloadAction<string>) => {
			state.tenantId = action.payload;
		},
		updateSite: (state, action: PayloadAction<LocationDocument | null>) => {
			state.hasInitializedChoice = true;
			if (!action.payload || action.payload === null) {
				delete state.location;
				delete state.tenantId;
			} else {
				if (!state.location) {
					state.location = action.payload;
				} else {
					Object.assign(state.location, action.payload);
				}
			}
		}
	}
});

export const { stampSiteTenantId, updateSite } = siteSlice.actions;

export default siteSlice.reducer;
